 
import ChildrensTooltip from '../../../../components/common/ChildrensTooltip';
import type { OptionProps } from 'react-select';

type OptionLayoutLocationTrackerOption = {
  label: string;
  value: string | null;
};

type OptionLayoutLocationTrackerProps = OptionProps<
  OptionLayoutLocationTrackerOption,
  false
>;

const OptionLayoutLocationTracker = (
  props: OptionLayoutLocationTrackerProps
) => {
  const { innerProps, innerRef } = props;
  return (
    <>
      <style>{`
          .customized-searchbox-option:hover{
            background-color:var(--falcon-gray-link-hover-300) !important;
          }
          .customized-searchbox-option{
            background-color:var(--falcon-tertiary-bg) !important;
          }
    
          `}</style>
      {props.data.value === "x" ? (
        <ChildrensTooltip html="اگر مکان مدنظر شما در لیست میزفا تولز نبود کافی هست در چت آنلاین درخواست مکان جدید رو رو اعلام کنید تا به ابزار اضافه کنیم.">
          <div
            ref={innerRef}
            {...innerProps}
            style={{
              backgroundColor: props.isSelected
                ? 'var(--falcon-gray-link-hover-100)'
                : 'var(--falcon-dropdown-bg-global)'
            }}
            className="p-2 cursor-pointer border border-1  customized-searchbox-option"
          >
            <div className="fs--1 ps-2 text-900 d-flex align-items-center gap-2">
              {/* {props.data?.label && (
            <img
              src={`https://static.mizfa.tools/flags/${props.data.label}.webp`}
              alt="country icon"
              width="20px"
              loading="lazy"
              height="11px"
            />
          )} */}
              {props.data.label}{' '}
            </div>
          </div>
        </ChildrensTooltip>
      ) : (
        <div
          ref={innerRef}
          {...innerProps}
          style={{
            backgroundColor: props.isSelected
              ? 'var(--falcon-gray-link-hover-100)'
              : 'var(--falcon-dropdown-bg-global)'
          }}
          className="p-2 cursor-pointer border border-1  customized-searchbox-option"
        >
          <div className="fs--1 ps-3 text-900 d-flex align-items-center gap-2">
            - {props.data.label}{' '}
          </div>
        </div>
      )}
    </>
  );
};

export default OptionLayoutLocationTracker;
